import { h } from 'preact'

const NavItem = ({ label, url }) => (<a class='navbar-item theme-font' href={url}>{label}</a>)

export default NavItem
